// extracted by mini-css-extract-plugin
export default {"neutral500":"#42434d","neutralWhite":"#fff","width32":"32px","WatchHome":"style_WatchHome__KcWjM","Vibe":"style_Vibe__yXBgG","CommentBtn":"style_CommentBtn__dF4bC"};